import { Component, Mixins, Prop, VModel } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import Role from '@/views/Authorization/models/role'

@Component
export default class RoleCheckbox extends Mixins<MixinInterface>() {
    @VModel() disabledBox!: boolean
    @Prop({ required: true }) role!: Role
    @Prop({ required: true }) permission!: string
    @Prop({ default: true }) disabled!: boolean

    loading = false

    get isIncluded() {
        return this.role.hasPermissionIncluded(this.permission)
    }

    get isActive() {
        return this.role.hasPermission(this.permission)
    }

    get isAvailable() {
        return this.role.isAvailablePermission(this.permission)
    }

    get checked() {
        return this.isActive || this.isIncluded
    }

    async togglePermission() {
        if (!this.disabledBox && !this.disabled && !this.isIncluded) {
            this.disabledBox = true
            this.loading = true
            await this.role.togglePermission(this.permission, this.currentProjectUser)
            this.loading = false
            this.disabledBox = false
        }
    }
}
